import React from "react";

const SK_STYLES = `
.hw-exskel{padding:24px 0}
.hw-exskel .bx{background:#e9edf3;border-radius:8px;animation:hwExPulse 1.4s ease-in-out infinite}
@keyframes hwExPulse{0%,100%{opacity:1}50%{opacity:.5}}
.hw-exskel--hero{background:#f3f7ff;border:1px solid #e3eafb;border-radius:14px;padding:22px 24px;display:flex;align-items:center;justify-content:space-between;gap:16px;margin-bottom:24px}
.hw-exskel--cols{display:flex;gap:24px;flex-wrap:wrap;align-items:flex-start}
.hw-exskel--main{flex:1 1 520px;min-width:0;display:flex;flex-direction:column;gap:20px}
.hw-exskel--aside{flex:0 0 360px;max-width:100%}
.hw-exskel--card{border:1px solid #e6e8ee;border-radius:14px;padding:20px}
.hw-exskel--row{display:flex;gap:14px;align-items:center}
@media (max-width:991px){.hw-exskel--aside{flex:1 1 100%}}
`;

const Bx = ({ w, h, r = 8, mb = 0, style }) => (
  <div className="bx" style={{ width: w, height: h, borderRadius: r, marginBottom: mb, ...style }} />
);

export const ExcursionConfirmSkeleton = () => (
  <div className="hw-page--width">
    <style>{SK_STYLES}</style>
    <div className="hw-exskel">
      <div className="hw-exskel--hero">
        <div>
          <Bx w="160px" h={16} mb={10} />
          <Bx w="220px" h={13} />
        </div>
        <Bx w="120px" h={38} r={10} />
      </div>

      <div className="hw-exskel--cols">
        <div className="hw-exskel--main">
          <div className="hw-exskel--card">
            <div className="hw-exskel--row" style={{ marginBottom: 18 }}>
              <Bx w="34px" h={34} r={999} />
              <Bx w="180px" h={18} />
            </div>
            {[0, 1, 2].map((i) => (
              <div className="hw-exskel--row" key={i} style={{ justifyContent: "space-between", padding: "12px 0", borderTop: i ? "1px solid #eef1f6" : "none" }}>
                <div className="hw-exskel--row">
                  <Bx w="30px" h={30} r={999} />
                  <Bx w="150px" h={14} />
                </div>
                <Bx w="70px" h={14} />
              </div>
            ))}
          </div>

          <div className="hw-exskel--card">
            <Bx w="190px" h={16} mb={16} />
            <Bx w="100%" h={13} mb={10} />
            <Bx w="94%" h={13} mb={10} />
            <Bx w="72%" h={13} />
          </div>
        </div>

        <div className="hw-exskel--aside">
          <div className="hw-exskel--card">
            <div className="hw-exskel--row" style={{ marginBottom: 16 }}>
              <Bx w="64px" h={64} r={10} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <Bx w="80%" h={16} mb={8} />
                <Bx w="55%" h={13} />
              </div>
            </div>
            {[0, 1, 2, 3].map((i) => (
              <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
                <Bx w="38%" h={13} />
                <Bx w="30%" h={13} />
              </div>
            ))}
            <Bx w="100%" h={1} style={{ background: "#eef1f6", margin: "6px 0 16px" }} />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <Bx w="35%" h={18} />
              <Bx w="28%" h={18} />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ExcursionConfirmSkeleton;
